import { defineComponent as _defineComponent } from 'vue'
import TutorialStep from "#src/components/TutorialStep.vue";

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useTutorialStore } from "#src/store-pyr.js";
import { steps } from "#src/tutorial-1.js";

export default /*@__PURE__*/_defineComponent({
  __name: 'Tutorial',
  setup(__props, { expose: __expose }) {
  __expose();

const { tutorialStep } = storeToRefs(useTutorialStore());


const activeStep = computed(() => {
    const index = tutorialStep.value;
    if (index < steps.length) {
        return {
            index: index,
            step: steps[index],
            first: index === 0,
            last: index === steps.length - 1,

        }
    } else {
        return null;
    }
});

const exitIntro = () => {
    console.log('exiting intro!');
    tutorialStep.value = steps.length;
};


const __returned__ = { tutorialStep, activeStep, exitIntro, TutorialStep }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})